import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import type { GalleryEntryDefinition } from './entries';

/**
 * One shared component's page section: its name as a linkable h2, what it is
 * for, where it lives, who uses it, then its states from the registry's
 * render.
 */
export function GalleryEntry({ entry }: { entry: GalleryEntryDefinition }) {
  return (
    <Box component="section" data-testid={`gallery-${entry.id}-section`} sx={{ mb: 6 }}>
      <Divider sx={{ mb: 3 }} />
      <Typography
        component="h2"
        variant="h6"
        id={entry.id}
        // Room for the fixed top bar when a contents link jumps here.
        sx={{ fontWeight: 600, scrollMarginTop: 80 }}
      >
        {entry.name}
      </Typography>
      <Typography color="text.secondary" sx={{ mt: 0.5 }}>
        {entry.purpose}
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        <Box
          component="code"
          // A path is one long unbreakable word; on a phone it has to wrap or
          // it is what pushes the page sideways.
          sx={{
            bgcolor: 'action.hover',
            px: 0.5,
            borderRadius: 0.5,
            overflowWrap: 'anywhere',
          }}
        >
          {entry.file}
        </Box>
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        Used by {entry.usedBy.join(', ')}.
      </Typography>

      {entry.render()}
    </Box>
  );
}
